import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../state';
import { enrolTiimStudyParticipant } from '../../../state/study-participant/tiim-study-participant/tiim-study-participant.actions';

@Component({
  selector: 'dashboard-intervention-switch-dialog',
  templateUrl: './intervention-switch-dialog.component.html',
  styleUrls: ['./intervention-switch-dialog.component.scss'],
})
export class InterventionSwitchDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { updatedTiimStudyParticipant: any },
    private store: Store<AppState>,
    private interventionDialog: MatDialogRef<InterventionSwitchDialogComponent>
  ) {}

  ngOnInit(): void {}

  save(): void {
    this.store.dispatch(
      enrolTiimStudyParticipant({
        tiimStudyParticipant: this.data.updatedTiimStudyParticipant,
      })
    );
    this.interventionDialog.close();
  }

  cancel(): void {
    this.interventionDialog.close();
  }
}
